export const BusinessType = 1;
export const FOOD_BUSINESS_TYPE = 1;
export const RETAIL_BUSINESS_TYPE = 2;
export const OrderSourceID = 3;
export const OrderModes = 4;
export const Day = 5;
export const ProductProperty = 6;
export const ComplainCategory = 7;
export const ComplainType = 8;

// MENU LIST ENUM
export const ID_podms = 20;
export const ID_dashboard = 2;

// Order Mode
export const TAKE_AWAY = 110;
export const DELIVERY = 111;
export const DINE_IN = 109;
export const FINISHED_WASTE = 112;
export const HOLD_ORDER_TAB = 113;

// Order Source
export const ODMS_ORDER_SOURCE = 196;
export const POS_ORDER_SOURCE = 193;

// User Roles
export const SUPER_ADMIN = 0;
export const COMPANY_ADMIN = 1;
export const CASHIER = 2;
export const AGENT = 3;
export const CALL_CENTER_ADMIN = 4;
export const BRANCH_ADMIN = 5;

// Local Storage
export const DAY_SHIFT_TERMINAL = "d_123_s_456_t_789";
export const TERMINAL_UNIQUE_ID =
  "98ea154a-t-413f-u-4437-i-bd22-d-e6700cb38ef2";
export const POS_TOKEN = "a95b6d45-p-3d18-o-43d2-s-8cc8-t-220f82049841";
export const HOLD_ORDER = "i86tenv3-h-pw5v-o-56ov-l-vg9n-d-v94jgt9i08oa";

// File URL
export const GRN_BULK_FILE_NAME = "SampleFileGrnUpload.xlsx";

// Printing Template
export const PRE_PAYMENT_BILL = 199;
export const KOT_TEMPLATE = 352;
export const SALE_RECIEPT = 358;
export const DUPLICATE_SALE_RECIEPT = 359;
export const SALE_RETURN = 361;
export const CONSOLIDATED_KOT = 385;
